import { buildPickupCardFromVisitItems } from './buildPickupCardFromVisitItems'
import type { IShopBoard, IVisitShopItem } from '../redux/shop'

/** Keep the active visit patient on the Shop board until Stop (includes delivered lines). */
export function applyCurrentVisitShopPin(
  board: IShopBoard,
  params: {
    pinActive: boolean
    patientId?: string
    firstname?: string | null
    lastname?: string | null
    profilePic?: string | null
    visitItems: IVisitShopItem[]
  },
): IShopBoard {
  if (!params.pinActive || !params.patientId || params.visitItems.length === 0) {
    return board
  }

  const pinCard = buildPickupCardFromVisitItems({
    patientId: params.patientId,
    firstname: params.firstname,
    lastname: params.lastname,
    profilePic: params.profilePic,
    visitItems: params.visitItems,
  })

  const orders = [...board.orders.filter((order) => order.patientId !== params.patientId), pinCard]

  return {
    ...board,
    count: orders.length,
    orders,
  }
}
